// src/components/AdBanner.tsx
import { useEffect } from 'react';

const AdBanner = () => {
  useEffect(() => {
    try {
      // Проверяем, что мы в браузере и скрипт AdSense загружен
      if (typeof window !== 'undefined' && window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (e) {
      console.error("AdSense initialization error:", e);
    }
  }, []);

  return (
    <div className="relative z-40 w-full flex justify-center my-8 pointer-events-auto">
      <div className="w-full max-w-3xl bg-white/95 dark:bg-[#050816]/95 backdrop-blur-sm rounded-xl p-4 border border-zinc-200/10 shadow-lg">
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-7513011226791912"
          data-ad-slot="1045281443"
          data-ad-format="autorelaxed"
          data-full-width-responsive="true"
        ></ins>
      </div>
    </div>
  );
};

export default AdBanner;